/* eslint-disable max-len */
import { styled, SxProps, Theme } from "@mui/material";

export const Row = styled("div")`
  display: flex;
  flex-direction: row;
`;

export const Column = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const PulseCircle = ({
  sx,
  sold,
  warning,
  hide,
}: {
  sx?: SxProps<Theme>;
  hide?: boolean;
  sold?: boolean;
  warning?: boolean;
}) => {
  if (hide) {
    return null;
  }
  return (
    <PulseWrap sx={sx} green={sold} warning={warning}>
      <PulseInner warning={warning} />
      <PulseInnerInvert warning={warning} />
    </PulseWrap>
  );
};

const PulseWrap = styled<any>("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin-right: 6px;

  & > div:first-of-type,
  & > div:last-of-type {
    opacity: 0.5;
  }
`;

const PulseInner = styled<any>("div")`
  width: 16px;
  height: 16px;
  position: absolute;
  background: ${({ theme, warning }) => warning ? theme.palette.warning.main : "#8cc63f"};
  
  border-radius: 50%;
  animation: PulseOuter 2s infinite;
`;

const PulseInnerInvert = styled<any>("div")`
  width: 8px;
  height: 8px;
  position: absolute;
  background: ${({ theme, warning }) => warning ? theme.palette.warning.dark : "#009245"};
  border-radius: 50%;
  animation: PulseInner 2s infinite;
`;
